import { PLATFORM_ENUM_ALL } from '@/services/enums'
import { menuListUrlToBaseApp } from '@/services/microFeUtil'
import { enumItemListToOptions, uniqueFunc } from '@/services/utils/modules/base'

const getters = {
  // 菜单权限
  permissionMenus: state => state.user.permissionMenus,
  bjMenuList: state => {
    return menuListUrlToBaseApp(state.user.bjMenuList)
  },
  commonMap: state => state.map.commonMap,
  utcTimeOffset: state => state.map.utcTimeOffset,
  initBtnShow: state => state.user.initBtnShow,
  operationLabel: state => state.map.operationLabel,
  operationLabelMap: state => {
    const obj = {}
    state.map.operationLabel.forEach(item => {
      obj[item.id] = item
    })
    return obj
  },
  // 已授权的平台 options
  grantedPlatformOptions: state => {
    const ids = state.map.commonMap.map(item => item.platformId).filter(id => !!id)
    const idsUniq = [...new Set(ids)]

    const items = Object.values(PLATFORM_ENUM_ALL).filter(item => {
      return idsUniq.includes(item.value)
    })

    return enumItemListToOptions(items)
  },
  getAllPlatformOptions: state => {
    const platformList = uniqueFunc(state.map.commonMap, 'platformId').filter(item => item.platformId !== 3)
    const items = (platformList || []).map(item => ({
      ...item,
      id: item.platformId,
      name: item.platformName
    }))

    return items
  },
  lastTaskStatus: state => state.immediateSales.lastTaskStatus,
}
export default getters
